import React, { useEffect } from 'react'
import LockerMenu from '../../Components/LockerMenu'
import { P,PageWrapper,BuyBtn,ChartBtn,ContentGrid,VideoBK,MainContainer,ImgGrid, } from '../../Styles/style'
import { Container, Grid } from '@mui/material'
import Secondsection from '../../sections/S2/secondsection'
import Tokenomics from '../../sections/tokenomics/tokenomics'
import Footer from '../../sections/footer/footer'
import AOS from 'aos'
import "aos/dist/aos.css";

const MainPage = (props) => {
  useEffect(() => {
    AOS.init();
    // AOS.refresh();
  },[]);

  return (
    <>
    <PageWrapper id="home">
        <VideoBK autoPlay loop playsInline muted>
            <source src="./assets/header-bg.mp4" type="video/mp4" />
          </VideoBK>
        <MainContainer maxWidth="xl">
    <LockerMenu />
          <Grid container>
            <ImgGrid item xs={12} sm={6}>
              <div data-aos="fade-right" data-aos-duration="3000"><img src="./assets/gear5-img.png" alt="" style={{width:"90%"}} /></div>
            </ImgGrid>
            <ContentGrid item xs={12} sm={6} data-aos="fade-up" data-aos-duration="3000">
              
                <video autoPlay loop playsInline muted style={{border:"1px solid #FE8343"}}>
                    <source src="./assets/gear-video.mp4" type="video/mp4" />
                </video>
                <P>After eight centuries, the sun god Nika has returned to the ethereum blockchain bringing $GEAR5 to rekindle the anime season's glory in the world of crypto and ushering in a new era of anime greatness.
                </P>
                <P>
                    Luffy’s $GEAR5 memecoin is about to start a new era for anime as we embark on the biggest moment in anime history happening tonight. Our mission stretches beyond anime and crypto, we are building a community of family and friends who laugh, love and grow together like Luffy’s pirate crew. Collectively, we will channel the influence of anime fandom, drawing inspiration from Luffy's unwavering determination to uplift those in need. Let’s Make Anime Great Again!
                </P>
                <div styled="margin-top:10px;">
                  <BuyBtn>Buy Now</BuyBtn>
                  <ChartBtn>View Chart</ChartBtn>
                </div>
            </ContentGrid>
          </Grid>
        </MainContainer>
    </PageWrapper>
    <Secondsection />
    <Tokenomics />
    <Footer />
    </>
  )
}

export default MainPage